import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/ExternalLink.svg?component
var ExternalLink_exports = /* @__PURE__ */ __exportAll({
	default: () => ExternalLink_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M6.4 4H20v13.59M4 20 20 4"
	}, null, -1)])]);
}
var ExternalLink_default = { render: render$1 };
//#endregion
export { ExternalLink_exports, ExternalLink_default as default, render$1 as render };

//# sourceMappingURL=ExternalLink.svg_component.js.map